import PropTypes from "prop-types";

export const _PostCard = {
  categories: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  image: PropTypes.object,
  isFeatured: PropTypes.bool,
  isStacked: PropTypes.bool,
  link: PropTypes.object,
  tags: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  type: PropTypes.string,
};

export const PostCardPropTypes = _PostCard;
